import { Component, OnInit } from '@angular/core';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { ReportMenuDto } from 'src/app/config/shared/dto/report-menu.dto';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { ReportFileService } from '../shared/report-file.service';
import { UserService } from 'src/app/users/shared/user.service';

@Component({
  selector: 'wl-reports-run-a-report',
  templateUrl: './reports-run-a-report.component.html',
  styleUrls: ['./reports-run-a-report.component.less'],
    standalone: false
})
export class ReportsRunAReportComponent implements OnInit {
  public reportsList: ReportMenuDto[];
  public hideEventReports = false;
  public hideRevenuReports = false;
  public hideAdminReports = false;
  public hideCustomReports = false;

  public constructor(
    private _configService: ConfigServiceService,
    private _navigationService: NavigationService,
    private _reportFileService: ReportFileService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this.getPermissions();
    this._configService.getFullReportsMenu().then((data) => {
      this.reportsList = data;

      if (this.hideAdminReports) {
        this.reportsList = this.reportsList.filter((x) => x.Title != 'Admin Reports');
      }
      if (this.hideEventReports) {
        this.reportsList = this.reportsList.filter((x) => x.Title != 'Event Reports');
      }
      if (this.hideRevenuReports) {
        this.reportsList = this.reportsList.filter((x) => x.Title != 'Revenue Reports');
      }

      if (this.reportsList.findIndex((x) => x.Title == 'Custom Reports') == -1 && !this.hideCustomReports) {
        this._reportFileService.getCustomReportDashboardMenu().then((customReport) => {
          this.reportsList.push(customReport);
        });
      }
    });
  }

  public openReport(report: ReportMenuDto) {
    this._navigationService.navigateToReport(report.ReportFileName);
  }

  private getPermissions() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Event Reports').then((result) => {
      this.hideEventReports = result == 0;
    });
    this._userService.getCurrentUserSecurityElementAccessLevel('Revenue Reports').then((result) => {
      this.hideRevenuReports = result == 0;
    });
    this._userService.getCurrentUserSecurityElementAccessLevel('Admin Reports').then((result) => {
      this.hideAdminReports = result == 0;
    });
    this._userService.getCurrentUserSecurityElementAccessLevel('Custom Reports').then((result) => {
      this.hideCustomReports = result == 0;
    });
  }
}
